var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isFilter
        ? _c("div", { staticClass: "q-mb-md" }, [
            _c("div", { staticClass: "row justify-ends" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "q-btn",
                    {
                      staticClass: "no-shadow",
                      attrs: {
                        icon: "add",
                        size: "sm",
                        flat: "",
                        color: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.newFormModalOpen = !_vm.newFormModalOpen
                        }
                      }
                    },
                    [
                      _vm._v(
                        "Add New " +
                          _vm._s(_vm._f("singular")(_vm.column.label))
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("q-btn", {
                    staticClass: "no-shadow",
                    attrs: {
                      label: "view data",
                      color: "secondary",
                      size: "sm",
                      disabled: !_vm.modelHasOption,
                      icon: "remove_red_eye",
                      flat: ""
                    },
                    on: {
                      click: function($event) {
                        _vm.infoModalOpen = !_vm.infoModalOpen
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm.loaded && _vm.options.length
        ? _c("q-select", {
            attrs: {
              value: _vm.modelId,
              options: _vm._f("qOptions")(_vm.options, _vm.labelField),
              multiple: false,
              align: _vm.column.align,
              "hide-underline": "",
              color: !_vm.isFilter ? _vm.color : "",
              "inverted-light": !_vm.isFilter,
              clearable: "",
              filter: "",
              "autofocus-filter": ""
            },
            on: { input: _vm.handleChange }
          })
        : _vm._e(),
      _vm.addButton && _vm.template === "form" && !_vm.isFilter
        ? _c(
            "div",
            [
              _c(
                "q-modal",
                {
                  attrs: {
                    "content-classes": "q-pa-lg",
                    "content-css": "min-width: 70vw; max-width: 95vw",
                    "no-backdrop-dismiss": "",
                    "no-esc-dismiss": ""
                  },
                  model: {
                    value: _vm.newFormModalOpen,
                    callback: function($$v) {
                      _vm.newFormModalOpen = $$v
                    },
                    expression: "newFormModalOpen"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "fit" },
                    [
                      _c("q-btn", {
                        staticStyle: {
                          top: "0",
                          right: "0",
                          position: "relative",
                          float: "right"
                        },
                        attrs: { flat: "", icon: "close" },
                        on: {
                          click: function($event) {
                            _vm.newFormModalOpen = false
                          }
                        }
                      }),
                      _vm.newFormModalOpen
                        ? _c(
                            "div",
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "q-display-1 text-secondary capitalize no-margin"
                                },
                                [
                                  _vm._v(
                                    "Add New " +
                                      _vm._s(
                                        _vm._f("singular")(_vm.column.label)
                                      )
                                  )
                                ]
                              ),
                              _vm.relationResource
                                ? _c(
                                    "base-form",
                                    {
                                      attrs: {
                                        resource: _vm.relationResource,
                                        "parent-resource": _vm.parentResource,
                                        "is-modal": true
                                      },
                                      on: { add: _vm.handleNew }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "full-width q-mt-md q-pb-lg",
                                          attrs: { slot: "goback" },
                                          slot: "goback"
                                        },
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              icon: "close",
                                              label: "Cancel / Close",
                                              color: "grey-6",
                                              flat: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.newFormModalOpen = false
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "q-modal",
                {
                  attrs: {
                    "content-classes": "q-pa-lg",
                    "content-css": "min-width: 70vw; max-width: 95vw"
                  },
                  model: {
                    value: _vm.infoModalOpen,
                    callback: function($$v) {
                      _vm.infoModalOpen = $$v
                    },
                    expression: "infoModalOpen"
                  }
                },
                [
                  _vm.modelHasOption
                    ? _c("div", [
                        _c("div", { staticClass: "q-pb-md" }, [
                          _c("span", { staticClass: "text-primary q-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.modelHasOption[_vm.labelField] ||
                                  "(no data for " + _vm.labelField + ")"
                              ) + " Info"
                            )
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "q-pb-md" },
                          [
                            _c("model-card-view", {
                              attrs: {
                                model: _vm.modelHasOption,
                                resource: _vm.relationResource
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "actions",
                                    fn: function(props) {
                                      return _c(
                                        "div",
                                        {},
                                        [
                                          _c("q-btn", {
                                            directives: [
                                              {
                                                name: "close-overlay",
                                                rawName: "v-close-overlay"
                                              }
                                            ],
                                            staticClass: "full-width",
                                            attrs: {
                                              color: "primary",
                                              label: "Close"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  }
                                ],
                                null,
                                false,
                                1763548924
                              )
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }